import { VariaveisAmbiente } from 'config';
import { useCallback } from 'react';
import { useApiBase } from '../../base/api-base';
import { useSessaoAtual } from 'services/app';
import { BoletoGetModel } from 'model/api/gestao/boleto/boleto-get-model';
import { NovoBoletoModel } from 'model/api/gestao/boleto/novo-boleto-model';

export function usePostBoleto() {
    const { invocarApi, ...outrasPropriedades } = useApiBase<BoletoGetModel>();

    const { getEmpresa } = useSessaoAtual();

    const postBoleto = useCallback(
        (model: NovoBoletoModel) =>{
            model.empresaId = getEmpresa().Id;
            return invocarApi({
                method: 'POST',
                url: `/${VariaveisAmbiente.apiVersion}/Empresa/${getEmpresa().Id}/boleto/novo-boleto`,
                data: model,
                enviarTokenUsuario: true
            })
        },
        [getEmpresa, invocarApi],
    );
    return {
        ...outrasPropriedades,
        postBoleto,
    };
}
